import type { ClickableItem, IsDropdownItem, VisibleItem } from 'layouts/main/sp-header/navigation/models';
import { NavigationItem } from 'layouts/main/sp-header/navigation/NavigationItem';
import type { IntlKey } from 'locales';
import { connect } from 'react-redux';
import {
  isSecondaryBatchVisible,
  isSecondaryOrderBlotterVisible,
  isSecondaryPostEventVisible,
  isSecondaryTradeBlotterVisible,
} from 'state/selectors/common/router';
import type { AppState } from 'state/state.model';

export type SecondaryMarketQuoteWorkspaceItemProps = { label?: IntlKey } & IsDropdownItem & ClickableItem;
export function SecondaryMarketQuoteWorkspaceItem({
  isDropdownItem,
  onClick,
  label,
}: SecondaryMarketQuoteWorkspaceItemProps) {
  return (
    <NavigationItem
      isDropdownItem={isDropdownItem}
      targetRoute="/secondary-market-quotes-workspace"
      label={label ?? 'appHeader.laptop.menu.secondaryMarket.quotes'}
      dataE2eSuffix="secondary-quotes-workspace"
      category="Workspace"
      action="Secondary market quotes workspace"
      onClick={onClick}
    />
  );
}

function SecondaryMarketBatchWorkspaceItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      isDropdownItem={isDropdownItem}
      targetRoute="/secondary-market-batch"
      label={'appHeader.laptop.menu.secondaryMarket.batch'}
      dataE2eSuffix="secondary-batch-workspace"
      category="Workspace"
      action="Secondary market batch workspace"
      onClick={onClick}
      isNewItem
    />
  );
}

export const ConnectedSecondaryMarketBatchWorkspaceItem = connect((state: AppState) => ({
  isVisible: isSecondaryBatchVisible(state),
}))(SecondaryMarketBatchWorkspaceItem);

export function SecondaryMarketOrdersBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      isDropdownItem={isDropdownItem}
      targetRoute="/secondary-orders-blotter"
      label="appHeader.laptop.menu.secondaryMarket.orderBlotter"
      dataE2eSuffix="secondary-orders-blotter"
      category="Workspace"
      action="Secondary market orders blotter"
      onClick={onClick}
    />
  );
}

export const ConnectedSecondaryMarketOrdersBlotterItem = connect((state: AppState) => ({
  isVisible: isSecondaryOrderBlotterVisible(state),
}))(SecondaryMarketOrdersBlotterItem);

export function SecondaryMarketPostTradeItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      isDropdownItem={isDropdownItem}
      targetRoute="/secondary-market-post-event-workspace"
      label="appHeader.laptop.menu.secondaryMarket.postEvent"
      dataE2eSuffix="secondary-post-event-workspace"
      category="Workspace"
      action="Secondary market post event workspace"
      onClick={onClick}
    />
  );
}

export const ConnectedSecondaryMarketPostTradeItem = connect((state: AppState) => ({
  isVisible: isSecondaryPostEventVisible(state),
}))(SecondaryMarketPostTradeItem);

export function SecondaryMarketTradeBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isDropdownItem={isDropdownItem}
      isVisible={isVisible}
      targetRoute="/secondary-trade-blotter"
      label="appHeader.laptop.menu.secondaryMarket.trades"
      dataE2eSuffix="secondary-market-trade-blotter"
      category="Workspace"
      action="Secondary market trades blotter"
      onClick={onClick}
    />
  );
}

export const ConnectedSecondaryMarketTradeBlotterItem = connect((state: AppState) => ({
  isVisible: isSecondaryTradeBlotterVisible(state),
}))(SecondaryMarketTradeBlotterItem);
